import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stateOffices',
  templateUrl: './stateOffices.component.html',
  styleUrls: ['./stateOffices.component.scss']
})
export class StateOfficesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
